import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { FaPhone, FaUser, FaExclamationTriangle } from 'react-icons/fa';
import { GiHelmet } from 'react-icons/gi';
import './ViewQR.css';

const ViewQR = () => {
  const { pathname } = useLocation(); // e.g. "/gabcdef123"
  const randStr = pathname.replace('/g', ''); // "abcdef123"
  const [qrInfo, setQrInfo] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchQRInfo = async () => {
      try {
        const response = await axios.get(`/api/v1/qr/${randStr}`);
        setQrInfo(response.data);
        setIsLoading(false);
      } catch (error) {
        if (error.response?.status === 429) {
          setError('Слишком много запросов. Пожалуйста, попробуйте позже.');
        } else {
          setError(error.response?.data?.detail || 'Не удалось загрузить информацию QR-карты');
        }
        setIsLoading(false);
      }
    };

    fetchQRInfo();
  }, [randStr]);

  if (isLoading) {
    return (
      <div className="view-qr-mobile text-center">
        <h2 className="emergency-title">Загрузка информации...</h2>
        <div className="loader"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="view-qr-mobile">
        <div className="qr-logo error-logo">
          <FaExclamationTriangle className="error-icon" />
        </div>
        <h2 className="emergency-title">Ошибка</h2>
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="view-qr-mobile">
      
      {qrInfo.comment && (
        <div className="comment-section">
          <div className="section-header">
            <h3 className="section-title">Комментарий</h3>
          </div>
          <div className="comment-container">
            <p className="comment-text">{qrInfo.comment}</p>
          </div>
        </div>
      )}
      
      <div className="emergency-section">
        <div className="section-header">
          <FaExclamationTriangle className="section-icon" />
          <h3 className="section-title">Экстренные контакты</h3>
        </div>
        
        <div className="contacts-container">
          {qrInfo.contacts && qrInfo.contacts.length > 0 ? (
            <div className="contacts-list-mobile">
              {qrInfo.contacts.map((contact, index) => (
                <div key={index} className="contact-card-mobile">
                  <div className="contact-info">
                    <h4 className="contact-name">{contact.name}</h4>
                    <p className="contact-relation">{contact.relation || 'Контакт'}</p>
                  </div>
                  <a href={`tel:${contact.phone}`} className="phone-button">
                    <FaPhone className="phone-icon" />
                    <span>{contact.phone}</span>
                  </a>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-contacts-container">
              <p className="no-contacts">Пользователь не добавил контакты</p>
            </div>
          )}
        </div>
      </div>
      
      <div className="footer-note">
        <p>Сканируйте QR-код для доступа к этой информации</p>
      </div>
      <div className="qr-add">
        <span className="qr-add-text">{qrInfo.id + 5555}</span>
      </div>
    </div>
  );
};

export default ViewQR;
